import type { ConsentTexts } from '../types';

export const en: ConsentTexts = {
  eyebrow: 'Privacy',
  bannerTitle: 'Cookie information on this website',
  bannerDescription: 'We would like to use cookies to understand website traffic, improve our services and make advertising more relevant.',
  actionsLabel: 'Cookie consent choices',
  acceptAll: 'Allow',
  rejectAll: 'Reject',
  settings: 'Settings',
  privacyLink: 'More information',
  settingsTitle: 'Cookie settings',
  settingsDescription: 'Choose the purposes for which we may use cookies. Necessary cookies are always enabled because the website cannot function properly without them.',
  saveSelection: 'Save settings',
  close: 'Close cookie settings',
  required: 'Always active',
  categories: {
    necessary: {
      name: 'Necessary',
      description: 'Provide the website’s essential functionality, security and availability.',
    },
    analytics: {
      name: 'Analytics',
      description: 'Help us understand how the website is used and improve its content.',
    },
    marketing: {
      name: 'Marketing',
      description: 'Allow us to measure campaigns and show more relevant advertising.',
    },
    remarketing: {
      name: 'Remarketing',
      description: 'Tracks user behaviour across websites to show advertising that is relevant and interesting to the user and therefore more valuable to publishers and third-party advertisers.',
    },
    email: {
      name: 'Email',
      description: 'Allows the user’s email address to be provided to third parties to better evaluate marketing activities and show relevant and interesting advertising.',
    },
    preferences: {
      name: 'Preferences',
      description: 'Remember your choices and allow the website to adapt its behaviour.',
    },
  },
};
